import { handleRequest } from '_services';

export const helpCenterService = {
    requestHelp,
    getLocationsForUser,
};

async function requestHelp(requestHelpMsg, requestHelpToAddress, requestHelpCategory, requestHelpIncludeIntegration) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ requestHelpMsg, requestHelpToAddress, requestHelpCategory, requestHelpIncludeIntegration })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/helpcenter/requesthelp', requestOptions, true);
}

async function getLocationsForUser(urno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/helpcenter/locations?urno=' + urno, requestOptions, true)
        .then(data => {
            return data;
        });
}
